import React from 'react';
import { Modal, Button, Row, Col, Input, Form } from 'antd';
import I18n from '@src/i18n';
import styled, { Theme } from '@src/styled-components';
import NotificationComponent from '@src/helpers/_showNotifications';
import QuillHtmlComponent from '@components/QuillHtmlEditorComponent';

interface ConfigurationItems {
  code: any;
  name: string;
  quantityMin: number;
  quantityMax: number;
  errorMessage: string,
  successMessage: string,
  partialMessage: string
}

interface Props {
  isVisible: boolean,
  configurationItems: Array<ConfigurationItems>;
  onSetConfigurationItems: any;
  onToggleModal: any;
};

export default class ImageRecognitionModalComponentProcess extends React.Component<Props, any> {
  private itemsModel: Object = { code: '', name: '', quantityMin: '', quantityMax: '', errorMessage: '', successMessage: '', partialMessage: '' }

  constructor(props: Props) {
    super(props);

    this.state = {
      configurationItems: [],
      valid: false
    };

    this.handleSetConfigurationItems = this.handleSetConfigurationItems.bind(this)
    this.addItemConfiguration = this.addItemConfiguration.bind(this)
    this.handleDeleteItem = this.handleDeleteItem.bind(this)
    this.validateFields = this.validateFields.bind(this)


  }

  componentDidMount() {
    const { configurationItems } = this.props
    const initial = configurationItems.length === 0 ? [this.itemsModel] : configurationItems
    this.setState({ configurationItems: initial })
  }

  handleSetConfigurationItems() {
    if(this.state.valid){
      const { onSetConfigurationItems, onToggleModal } = this.props
      onSetConfigurationItems(this.state.configurationItems)
      onToggleModal()
    }else{
      NotificationComponent.Notify('error', I18n.l('common.error'), I18n.l('formflow.errors.save'))
    }
  }

  addItemConfiguration() {
    const { configurationItems } = this.state
    const configurationItemsPlus = [...configurationItems, this.itemsModel]
    this.setState({ configurationItems: configurationItemsPlus })
  }

  handleChangeValue(value: any, index: any, key: any,ed : any) {
    const { configurationItems } = this.state
    const item = { ...configurationItems[index] }
    item[key] =  ed && ed.getLength() > 1 || !ed ? value : ''
    const final = [...configurationItems]
    final[index] = item
    let valid = this.validateFields(final,index)
    this.setState({
      configurationItems: final,
      valid: valid
    })

  }
  validateFields(configurationItems: any,index: any) {
    let fields = Object.keys(configurationItems[index])
      let invalid = fields.some((field: any) =>  configurationItems[index][field] === '' || configurationItems[index][field] === '↵')
    return !invalid
  }
  handleDeleteItem(index: number) {
    const { configurationItems } = this.state
    const newConfigurationItems = [...configurationItems]
    newConfigurationItems.splice(index, 1)
    this.setState({ configurationItems: newConfigurationItems })
  }
  render() {
    const { isVisible, onToggleModal } = this.props
    const { configurationItems, valid } = this.state

    return (
      <Modal
        visible={isVisible}
        footer={false}
        closable={false}
        destroyOnClose={true}
        title={I18n.l('imageRecognition.modal.title')}
        className="image-recognition-modal"
        width={'90%'}
        style={{top : '2vh'}}
      >
        <ModalStyle>
          <Row>
            <Col>
              <p className="margin-bottom">{I18n.l('imageRecognition.modal.description')}</p>
            </Col>
          </Row>

          <Row className="header" gutter={[8, 0]} type="flex" align="bottom">
            <Col span={7}>{I18n.l('imageRecognition.modal.fieldConf')}</Col>
            <Col span={5}>{I18n.l('label.errorMessage')}</Col>
            <Col span={5}>{I18n.l('label.successMessage')}</Col>
            <Col span={5}>{I18n.l('label.partialMessage')}</Col>
          </Row>

          {configurationItems.map((r: ConfigurationItems, index: any) => (
            <>
              <Form>
                <Row gutter={[8, 0]} type="flex" align="top" key={index}>

                  <Col span={7}>
                    <Row gutter={[8, 16]}>
                      <Col span={10} >
                        <Input placeholder={I18n.l('imageRecognition.modal.fieldCode')} value={r.code} onChange={(e: any) => this.handleChangeValue(e.target.value, index, 'code',false)} />
                      </Col>
                      <Col span={14}>
                        <Input placeholder={I18n.l('imageRecognition.modal.fieldName')} value={r.name} onChange={(e: any) => this.handleChangeValue(e.target.value, index, 'name',false)} />
                      </Col>
                    </Row>
                    <Row gutter={[8, 0]}>
                      <Col span={6}>
                        <Input placeholder={I18n.l('imageRecognition.modal.fieldQttMin')} value={r.quantityMin} onChange={(e: any) => this.handleChangeValue(e.target.value, index, 'quantityMin',false)} />
                      </Col>
                      <Col span={6}>
                        <Input placeholder={I18n.l('imageRecognition.modal.fieldQttMax')} value={r.quantityMax} onChange={(e: any) => this.handleChangeValue(e.target.value, index, 'quantityMax',false)} />
                      </Col>
                    </Row>
                    <Row></Row>
                  </Col>

                  <Col span={5}>
                    <CardConfig>
                      <QuillHtmlComponent
                        height={'100px'}
                        defaultValue={r.errorMessage}
                        placeholder={I18n.l("label.components.writeHere")}
                        onTextChange={(e: any,d: any,s: any,ed: any) => this.handleChangeValue(e, index, 'errorMessage',ed)}
                      />
                    </CardConfig>
                    <LabelRequired>* {I18n.l('formflow.labels.required')}</LabelRequired>
                  </Col>
                  <Col span={5}>
                    <CardConfig>
                      <QuillHtmlComponent
                        height={'100px'}
                        defaultValue={r.successMessage}
                        placeholder={I18n.l("label.components.writeHere")}
                        onTextChange={(e: any,d: any,s: any,ed: any) => this.handleChangeValue(e, index, 'successMessage',ed)}
                      />
                    </CardConfig>
                    <LabelRequired>* {I18n.l('formflow.labels.required')}</LabelRequired>
                  </Col>
                  <Col span={5}>
                    <CardConfig>
                      <QuillHtmlComponent
                        height={'100px'}
                        defaultValue={r.partialMessage}
                        placeholder={I18n.l("label.components.writeHere")}
                        onTextChange={(e: any,d: any,s: any,ed: any) => this.handleChangeValue(e, index, 'partialMessage',ed)}
                      />
                    </CardConfig>
                    <LabelRequired>* {I18n.l('formflow.labels.required')}</LabelRequired>
                  </Col>

                  <Col span={2} className='alignSelf'>
                    <Button type="danger" ghost onClick={() => this.handleDeleteItem(index)}>
                      {I18n.l('common.delete')}
                    </Button>
                  </Col>
                </Row>
              </Form>
              <DividerBorder />
              {!valid && <LabelRequired>* {I18n.l('formflow.errors.save')}</LabelRequired>}
            </>
          ))}

          <Row className="add-button">
            <Col className="text-left">
              <Button onClick={this.addItemConfiguration} type="link">
                + {I18n.l('imageRecognition.modal.addItem')}
              </Button>
            </Col>
          </Row>

          <Row className="footer">
            <Col className="text-right">
              <Button onClick={onToggleModal} type="link">
                {I18n.l('common.cancel')}
              </Button>

              <Button type="primary" className="ml-1" onClick={this.handleSetConfigurationItems}>
                {I18n.l('common.create')}
              </Button>
            </Col>
          </Row>
        </ModalStyle>
      </Modal>
    );
  }
}

const ModalStyle = styled.div`
  height: 80vh;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 0;
  
  .header {
    margin-bottom: 15px;
  }
  .fields:not(:first-child):not(:last-child) {
    margin-top: 5px;
    margin-bottom: 5px;
  }
  .add-button {
    margin-top: 15px;
  }
  .footer {
    margin-top: 15px;
  }
  .text-right {
    text-align: right;
  }
  .padding-x {
    padding:0 10px;
  }
  .padding-left {
    padding-left: 10px;
  }
  .margin-bottom {
    margin-bottom: 30px;
  }
  .alignSelf{
    align-self: center;
  }
  .ant-btn{
    border: 0px;
    box-shadow none;
  }
`;

const CardConfig = styled.div`
  background-color: #F6FCFD;
  .quill {
    background: white;
    width:100%;
  }
`;
const DividerBorder = styled.div`
    border-bottom: 1px solid  ${Theme.secondary.lightGrey};
    margin: 10px 0px 20px 0px;
    width: 100%;
`;

const LabelRequired = styled.sup`
  color : red
`
